<template>
  <q-btn
    :data-testid="dataTestIds.COMMON.ADD_EXTENSION_BUTTON"
    type="a"
    target="_blank"
    :href="buttonProps.link"
    flat
    color="white"
    class="add-extension-btn hvr-grow-rotate"
  >
    <h6 class="q-mx-md text-weight-medium">{{ buttonProps.text }}</h6>
  </q-btn>
</template>

<script setup>
import dataTestIds from 'app/cypress/e2e/dataTestIds';
import useExtensionProps from 'src/composables/extensionProps';
import { computed } from 'vue';

const { buttonOptions } = useExtensionProps();

const buttonProps = computed(() => {
  return buttonOptions();
});
</script>

<style lang="scss" scoped>
.add-extension-btn {
  width: 270px;
  min-height: 60px;
  height: fit-content;
  background: $red-primary;
  border-radius: 6px;

  h6 {
    font-size: 16px;
    text-transform: none;
  }
}
</style>
